module.exports = __webpack_public_path__ + "img/trash.86007413.svg";